export default [
	{
		name: 'clone',
		icon: 'fa-copy',
		method: 'copyElement',
		classes: [],
		hoverable: false,
		menu: null,
	},
	{
		name: 'move',
		icon: 'fa-arrows-alt',
		method: null,
		classes: ['component-handle'],
		hoverable: false,
		menu: null,
	},
	{
		name: 'delete',
		icon: 'fa-trash-alt',
		method: 'removeParent',
		classes: [],
		hoverable: false,
		menu: null,
	},
	{
		name: 'settings',
		icon: 'fa-cog',
		method: 'openMenu',
		classes: [],
		hoverable: true,
		menu: 'button-menu',
	}
]